export interface TransactionalEmailActivityCreateRequestModel {
  name: string;
  emailFrom: string;
  emailFromName: string;
  mailServerId?: number | null;
  emailSubject: string;
  emailContent: string;
  emailMjmlContent: string;
}
